import CardModifier from './CardModifier';
import GameObject from '../../../../GameObject/GameObject';
import Pickaxe from '../Pickaxe';
import { addDragonbonesResources } from 'Utility/Resource/ResourceHelper';
import { DRAGONBONES_PATH } from 'Constants/Dragonbones';

export default class PickaxeModifier extends CardModifier {
    onCreate(params: any): void {
        super.onCreate(params);

        this.addChild(GameObject.Instantiate(Pickaxe));
    }

    public static async preload(): Promise<void> {
        addDragonbonesResources('pickaxe03_pickaxe', `${DRAGONBONES_PATH}/Pickaxe/`);
    }  
}
